export const ContainerStyles = (props: any) => `
  display: flex;
  height: ${props.theme.controlHeight};
  width: 78px;
  border-radius: 8px;
  flex-direction: row;
  justify-content: center;
  padding: 2px;
  margin-left: 8px;
`;

export const UnitContainerStyles = (props: any) => `
  display: flex;
  margin: 2px;
  max-width: 38px;
  flex: 1;
  background-color: ${props.isActive ? props.theme.primary.c200 : props.theme.secondary.c100};
  border: 1px solid ${props.isActive ? props.theme.primary.c500 : props.theme.secondary.c400};
  border-radius: 8px;
  justify-content: center;
  align-items: center;
`;

export const UnitTextStyles = (props: any) => `
  color: ${props.isActive ? props.theme.primary.c700 : props.theme.secondary.c600};
  font-weight: ${props.theme.fontWeight.semibold};
  text-transform: capitalize;
`;
